import React, { useContext } from 'react'
import { Trans } from 'react-i18next'
import { reportFilterContext } from './report-filter-context'
import { useExport } from '../../contexts'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'

export function NoFilteredItemsNote({ hideOnExport = true }: { hideOnExport?: boolean }) {
  const { _t } = useTypedTranslation()
  const { exporting } = useExport()
  const filterContext = useContext(reportFilterContext)
  const filterActive = filterContext.isFilterActive

  const toggleFile = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    filterContext.setFilterActive(!filterActive)
  }

  if (exporting) {
    return hideOnExport ? null : <i className="text-muted">{_t('no-data')}</i>
  }

  return (
    <div className="text-muted">
      <i>
        <Trans i18nKey={'similarities-not-found'}>
          Found no data matching current
          <a href="#" onClick={toggleFile} className="text-transform-none text-i">
            filter
          </a>
        </Trans>
      </i>
    </div>
  )
}
